import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
import { popupNames, popupCities, PRODUCT_IMAGE } from '../data/content';
function pick<T>(arr: T[]): T {
  return arr[Math.floor(Math.random() * arr.length)];
}
type Notice = {
  id: number;
  name: string;
  city: string;
  minutes: number;
};
export function PurchasePopup() {
  const [notice, setNotice] = useState<Notice | null>(null);
  useEffect(() => {
    let hideTimer = 0;
    let nextTimer = 0;
    let counter = 0;
    const show = () => {
      counter += 1;
      setNotice({
        id: counter,
        name: pick(popupNames),
        city: pick(popupCities),
        minutes: Math.floor(Math.random() * 14) + 2
      });
      hideTimer = window.setTimeout(() => setNotice(null), 6000);
      nextTimer = window.setTimeout(show, 6000 + Math.floor(Math.random() * 9000) + 8000);
    };
    const first = window.setTimeout(show, 5000);
    return () => {
      window.clearTimeout(first);
      window.clearTimeout(hideTimer);
      window.clearTimeout(nextTimer);
    };
  }, []);
  return <div className="pointer-events-none fixed inset-x-0 bottom-4 z-50 flex justify-center px-4" data-id="element-175" data-mp="116d0jxilnxd0">
      <AnimatePresence data-id="element-176" data-mp="1fv969nx6oyag">
        {notice && <motion.div key={notice.id} role="status" aria-live="polite" initial={{
        opacity: 0,
        y: 24,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 16,
        scale: 0.97
      }} transition={{
        duration: 0.35,
        ease: [0.22, 1, 0.36, 1]
      }} className="pointer-events-auto flex w-full max-w-sm items-center gap-3 rounded-2xl border border-[#c9d6cd] bg-white/95 p-3 shadow-xl shadow-[#16302a]/15 backdrop-blur" data-id="element-177" data-mp="1awzapc7jrvob">
            <img src={PRODUCT_IMAGE} alt="" className="h-11 w-11 shrink-0 rounded-lg border border-[#e4ebe5] object-contain p-0.5" data-id="element-178" data-mp="28jetchbpmzdg" />
            <div className="min-w-0 flex-1" data-id="element-179" data-mp="2apcr8yu90zhe">
              <p className="text-[12.5px] font-bold leading-snug text-[#16302a]" data-id="element-180" data-mp="2aqnu8wfve37g">
                {notice.name} de {notice.city} compró este libro digital
              </p>
              <p className="mt-0.5 flex items-center gap-1 text-[11px] text-[#6b7b73]" data-id="element-181" data-mp="2ko294rm5ajxn">
                <CheckCircle2Icon className="h-3.5 w-3.5 text-[#6f8f7c]" aria-hidden="true" data-id="element-182" data-mp="2pksr5khifplp" />
                Compra verificada · hace {notice.minutes} min
              </p>
            </div>
            <button type="button" onClick={() => setNotice(null)} aria-label="Cerrar aviso" className="shrink-0 rounded-full p-1 text-[#9aa8a0] transition hover:bg-[#f0f4f1] hover:text-[#3f5d4e]" data-id="element-183" data-mp="1wwdeh4lupjdj">
              <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-184" data-mp="197lrqsr15t85" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}